// eslint-disable-next-line no-restricted-imports
import styled from '@emotion/styled';
import { Box, Flex, Typography } from '@iheartjane/reefer';

import type { Feeling } from '@jane/search/types';
import { FEELING_ICONS } from '@jane/search/util';

export interface FeelingCardProps {
  feeling: Feeling;
  selected?: boolean;
  width?: string;
}

const FeelingContainer = styled(Box)<{ flexBasis?: string }>(
  ({ flexBasis }) => ({ flexBasis })
);

export const FeelingCard = ({ feeling, selected, width }: FeelingCardProps) => {
  const Icon = FEELING_ICONS[feeling];

  return (
    <FeelingContainer
      border={selected ? 'purple' : undefined}
      background="grays-ultralight"
      borderRadius="lg"
      p={12}
      minWidth="fit-content"
      flexBasis={width}
    >
      <Flex flexDirection="column" alignItems="center" justifyContent="center">
        {/* Guarded: FEELING_ICONS is keyed by tag value, and `feeling` arrives
            from an unchecked cast upstream (menuProductDetail.tsx). An unmapped
            value must degrade to a label without an icon, never throw. */}
        {Icon && <Icon size="md" />}
        <Typography color="grays-black">{feeling}</Typography>
      </Flex>
    </FeelingContainer>
  );
};
